export default __webpack_public_path__ + "static/media/bulk.9be15fa4.svg";